import AdPauses from '../components/pages/AdPauses/AdPauses'
import AdPausesContent from '../components/pages/AdPauses/AdPausesContent'
import AdVideosContent from '../components/pages/AdPauses/AdVideosContent'

export default [
  {
    path: '/pauses',
    name: 'AdPauses',
    component: AdPauses,
    redirect: {
      name: 'ActiveAdPauses'
    },
    children: [
      {
        path: 'active',
        name: 'ActiveAdPauses',
        component: AdPausesContent,
        meta: {
          statusId: 'active',
          newGui: true
        }
      },
      {
        path: 'archive',
        name: 'ArchiveAdPauses',
        component: AdPausesContent,
        meta: {
          statusId: 'inactive',
          newGui: true
        }
      },
      {
        path: 'videos/active',
        name: 'ActiveAdVideos',
        component: AdVideosContent,
        meta: {
          newGui: true,
          statusId: 1
        }
      },
      {
        path: 'videos/moderation',
        name: 'ModeratedAdVideos',
        component: AdVideosContent,
        meta: {
          newGui: true,
          statusId: 2 
        }
      },
      {
        path: 'videos/archive',
        name: 'ArchiveAdVideos',
        component: AdVideosContent,
        meta: {
          newGui: true,
          statusId: 3
        }
      }
    ]
  }
]
